import wordmarkPrimary from "@/assets/paradoxedge-wordmark-primary.png.asset.json";
import wordmarkReversed from "@/assets/paradoxedge-wordmark-reversed.png.asset.json";

type Variant = "primary" | "reversed";

interface LogoProps {
  variant?: Variant;
  height?: number;
  className?: string;
}

const Logo = ({ variant = "primary", height = 32, className = "" }: LogoProps) => {
  const src = variant === "reversed" ? wordmarkReversed.url : wordmarkPrimary.url;
  // Wordmark PNGs are 500x175 (~2.857 ratio)
  const width = Math.round(height * (500 / 175));
  return (
    <img
      src={src}
      alt="ParadoxEdge"
      width={width}
      height={height}
      style={{ height, width: "auto" }}
      className={className}
      loading="eager"
      decoding="async"
    />
  );
};

export default Logo;
